import styled from 'styled-components';
import ModalWithHeader from '@gcc/pip-components/dist/ModalWithHeader';
import { sizes } from '../../utils/style-utils';

export const WhatIsThisModalWithHeader = styled(ModalWithHeader)`
  > div {
    width: auto;
    & h2 {
      /* font-family: Helvetica Neue LT Pro; */
      font-style: normal;
      /* font-weight: normal; */
      font-size: 2.4rem;
      line-height: 2.8rem;
    }
    @media only screen and (min-width : ${sizes.tablet}) {
      width: inherit;
    }
  }
`;

export const DictionaryText = styled.div`
  padding: 0 !important;
`;

export const DictionaryMedia = styled.div`
  order: -1;
  padding: 0;
  max-width: 300px;
  @media only screen and (min-width : ${sizes.tablet}px)
  {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  @media only screen and (max-width : ${sizes.mobile}px)
  {
    display: flex !important;
    justify-content: center !important;
    width: 100% !important;
    margin-top: 15px;
  }
`;

export const DictionaryMediaImage = styled.img`
  width: 300px;
  padding: 0;
  margin: 0;
  @media only screen and (max-width : ${sizes.mobile}px) {
    width: 250px;
    padding: 0px 0px 2rem 0px;
  }
`;

export const ModalContent = styled.div`
  font-size: 1.4rem;
  padding: 1rem 2rem 0 2rem;
  display: flex;
  flex-direction: row;
  overflow: auto;
  justify-content: space-between;
  white-space: normal;
  @media only screen and (min-width : ${sizes.tablet}px)
  {
    justify-content: space-between;
    flex-wrap: nowrap;
  }
  @media only screen and (max-width : ${sizes.mobile}px)
  {
    justify-content: center;
    flex-wrap: wrap;
  }
  & h1 {
    margin-bottom: 1.93rem;
    order: -2;
    flex: 1 0 100%;
    padding: 0 2rem 0 5rem;
    /* font-family: Helvetica Neue LT Pro; */
    font-style: normal;
    font-weight: 600;
    font-size: 1.8rem;
    line-height: 2.8rem;
    @media only screen and (max-width : ${sizes.mobile}px)
    {
      padding: 0px;
    }
  }
  & p {
    padding: 0 2rem 0 5rem;
    text-align: left;
    line-height: 2.1rem;
    /* font-family: Helvetica Neue LT Pro; */
    font-style: normal;
    font-weight: normal;
    font-size: 1.4rem;
    @media only screen and (min-width : ${sizes.tablet}px)
    {
      padding: 0 2rem 0 5rem;
    }
    @media only screen and (max-width : ${sizes.mobile}px)
    {
      padding: 0px;
    }
  }
  table {
  flex: 0 1 auto;
    th, td {
      padding: 0 1rem;
    }
  }
  & ul, ol {
    display: block;
    margin-left: 0px;
    margin-right: 0px;
    padding-left: 2rem;
  }
  ul {
    list-style-type: disc;
  }
`;